(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-collection-grid"] && !Shopify.designMode) return;
  try {
    
  class PetCollectionGrid extends HTMLElement {
    connectedCallback() {
      const sort = this.querySelector('[data-sort]');
      if (sort) {
        sort.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      }
    }
  }
  if (!customElements.get('pet-collection-grid')) customElements.define('pet-collection-grid', PetCollectionGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-collection"] && !Shopify.designMode) return;
  try {
    
  class PetCollection extends HTMLElement {
    connectedCallback() {
      const sort = this.querySelector('[data-sort]');
      if (sort) {
        sort.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      }

      // grid / list switch — no reload, just swaps the modifier class
      const list = this.querySelector('[data-product-list]');
      const btns = this.querySelectorAll('.fn-view__btn');
      if (list && btns.length) {
        btns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const view = btn.dataset.view;
            list.classList.toggle('fn-list--grid', view === 'grid');
            btns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.view === view)));
            try { localStorage.setItem('pet:collection-view', view); } catch (e) {}
          });
        });
      }
    }
  }
  if (!customElements.get('pet-collection')) customElements.define('pet-collection', PetCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-customers-login"]) return;
  try {
    
  class PetLogin extends HTMLElement {
    connectedCallback() {
      const login = this.querySelector('[data-view="login"]');
      const recover = this.querySelector('[data-view="recover"]');
      const show = (which) => {
        login.hidden = which !== 'login';
        recover.hidden = which !== 'recover';
      };
      this.querySelector('[data-recover-open]')?.addEventListener('click', () => show('recover'));
      this.querySelector('[data-recover-close]')?.addEventListener('click', () => show('login'));
      // after a recover submit the page reloads with a message inside the recover form — open it
      if (recover.querySelector('.acct-msg') || location.hash === '#recover') show('recover');
    }
  }
  if (!customElements.get('pet-login')) customElements.define('pet-login', PetLogin);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-hero-slider"] && !Shopify.designMode) return;
  try {
    
class HeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hs__slide'));
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    if (this.slides.length <= 1) return;
    this.index = 0;
    this.interval = Number(this.dataset.autoplay) || 0;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.interval = 0;

    const prev = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
    if (next) next.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, n) => dot.addEventListener('click', () => this.go(n)));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.play());
    this.play();
  }
  show(n) {
    this.index = (n + this.slides.length) % this.slides.length;
    this.slides.forEach((s, k) => s.toggleAttribute('data-active', k === this.index));
    this.dots.forEach((d, k) => d.toggleAttribute('data-on', k === this.index));
  }
  go(n) { this.show(n); this.play(); }
  play() { this.stop(); if (this.interval) this.timer = setInterval(() => this.show(this.index + 1), this.interval); }
  stop() { if (this.timer) clearInterval(this.timer); }
  disconnectedCallback() { this.stop(); }
}
customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-newsletter"] && !Shopify.designMode) return;
  try {
    
class PetNewsletter extends HTMLElement {
  connectedCallback() {
    const tagsInput = this.querySelector('[data-mc-tags]');

    // Everything the shopper picks ends up in contact[tags] — the only field
    // Shopify's customer form carries through to Mailchimp. Base tags come from
    // the section setting via a data attribute (Liquid can't be used in here);
    // chips add "<prefix><value>" and each ticked box adds its own tag.
    const syncTags = () => {
      if (!tagsInput) return;
      const base = (tagsInput.dataset.baseTags || 'newsletter, home')
        .split(',').map((t) => t.trim()).filter(Boolean);
      const tags = base.slice();
      this.querySelectorAll('[data-mc-moods]').forEach((group) => {
        const prefix = group.dataset.tagPrefix || '';
        group.querySelectorAll('.mc__chip.on').forEach((c) => tags.push(prefix + c.dataset.mood));
      });
      this.querySelectorAll('.mc__cb[data-mc-tag]').forEach((cb) => {
        if (cb.checked && cb.dataset.mcTag) tags.push(cb.dataset.mcTag);
      });
      tagsInput.value = tags.join(', ');
    };

    this.querySelectorAll('[data-mc-moods] .mc__chip').forEach((chip) => {
      chip.addEventListener('click', () => {
        chip.classList.toggle('on');
        chip.setAttribute('aria-pressed', chip.classList.contains('on') ? 'true' : 'false');
        syncTags();
      });
    });

    // The tick visuals follow a real checkbox, so the opt-in can be `required`
    // and the browser blocks submission if it's unticked.
    this.querySelectorAll('[data-mc-consent]').forEach((row) => {
      const cb = row.querySelector('.mc__cb');
      if (!cb) return;
      row.classList.toggle('on', cb.checked);
      cb.addEventListener('change', () => {
        row.classList.toggle('on', cb.checked);
        syncTags();
      });
    });

    syncTags();
  }
}
customElements.define('pet-newsletter', PetNewsletter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-picks"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pk-loadmore]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var hidden = document.querySelectorAll('.pk-card.pk-more.is-hidden');
      hidden.forEach(function (card, i) {
        card.classList.remove('is-hidden');
        card.classList.add('pk-reveal');
        card.style.animationDelay = (i * 0.08) + 's';
      });
      var wrap = btn.closest('.pk-loadwrap');
      if (wrap) wrap.classList.add('is-done');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-product"] && !Shopify.designMode) return;
  try {
    
class PetProduct extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('[data-gift-row]')?.closest('form') || this;
    // gift wrapping moved to the cart — see main-cart-footer.liquid
    // note toggle → show textarea + enable property
    const noteBtn = this.querySelector('[data-gift-note]');
    const noteProp = this.querySelector('[data-prop-note]');
    if (noteBtn && noteProp) {
      noteProp.disabled = true;
      noteBtn.addEventListener('click', () => {
        const on = noteBtn.classList.toggle('is-on');
        noteBtn.setAttribute('aria-pressed', on);
        noteProp.classList.toggle('hide', !on);
        noteProp.disabled = !on;
        if (on) noteProp.focus();
      });
    }
    // ---- variant picker -------------------------------------------------
    // Only present when the product has real options. Resolves the chosen
    // option combination to a variant, then syncs the hidden id input (which
    // is what product-form.js actually POSTs), the price, the button label
    // and the wishlist button. Also rewrites the URL so a refresh or a shared
    // link keeps the selection, and swaps the gallery image when the variant
    // carries its own.
    const opts = this.querySelector('[data-variants]');
    if (opts) {
      let variants = [];
      try { variants = JSON.parse(opts.querySelector('[data-variant-json]').textContent); } catch (e) { variants = []; }
      const idInput = this.querySelector('.product-variant-id');
      const priceEl = this.querySelector('[data-price]');
      const labelEl = this.querySelector('[data-add-label]');
      const addBtn = this.querySelector('button[type="submit"][name="add"]');
      const wishBtn = this.querySelector('.wishbtn[data-wish]');
      // Reuse the server-rendered price as a template and swap the number in,
      // so the currency symbol and the shop's money format are preserved
      // without re-implementing them here.
      const tpl = priceEl ? priceEl.textContent.trim() : '';
      const money = (cents) => tpl.replace(/[\d.,]+/, () => (cents / 100).toFixed(2));
      const rows = [...opts.querySelectorAll('.popt')];
      const chosen = () => rows.map((row) => {
        const on = row.querySelector('.popt__btn.is-on');
        return on ? on.dataset.val : null;
      });
      const apply = (v) => {
        if (!v) {
          if (labelEl) labelEl.textContent = 'Unavailable';
          if (addBtn) addBtn.disabled = true;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (addBtn) addBtn.disabled = !v.available;
        if (priceEl) priceEl.textContent = money(v.price);
        if (labelEl) labelEl.textContent = v.available ? 'Add to bag \u00b7 ' + money(v.price) : 'Sold out';
        if (wishBtn) {
          wishBtn.dataset.variant = v.id;
          wishBtn.dataset.price = money(v.price);
        }
        // Dawn normally drives this from product-info.js, which this section
        // doesn't use — so refresh the pickup panel from our own picker.
        const pk = this.querySelector('pickup-availability');
        if (pk && typeof pk.update === 'function') pk.update(v);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
        if (v.featured_image && v.featured_image.src) {
          const main = document.querySelector('.pgal__main img, .pgal img');
          if (main) main.src = v.featured_image.src;
        }
      };
      opts.addEventListener('click', (e) => {
        const btn = e.target.closest('.popt__btn');
        if (!btn) return;
        e.preventDefault();
        btn.closest('.popt').querySelectorAll('.popt__btn').forEach((b) => {
          b.classList.toggle('is-on', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        const want = chosen();
        apply(variants.find((v) => want.every((val, i) => val === null || v.options[i] === val)));
      });
    }

    // quantity stepper
    const val = this.querySelector('[data-qty-val]');
    const input = this.querySelector('[data-qty-input]');
    const set = (n) => { n = Math.max(1, n); val.textContent = n; input.value = n; };
    this.querySelector('[data-qty-minus]')?.addEventListener('click', () => set(parseInt(val.textContent) - 1));
    this.querySelector('[data-qty-plus]')?.addEventListener('click', () => set(parseInt(val.textContent) + 1));
    // libro modal
    const scrim = document.querySelector('[data-libro-modal]');
    const open = () => scrim && scrim.classList.add('open');
    const close = () => scrim && scrim.classList.remove('open');
    this.querySelector('[data-libro-open]')?.addEventListener('click', open);
    scrim?.querySelector('[data-libro-close]')?.addEventListener('click', close);
    scrim?.addEventListener('click', (e) => { if (e.target === scrim) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }
}
customElements.define('pet-product', PetProduct);

  } catch(e) { console.error(e); }
})();
})();
